import React, { useEffect, useState } from "react";
import { getUVById } from "./../../../services/uvServices";

function AdherentUV({ adherentId }) {
  const [uvs, setUVs] = useState(null);
  const [status, setStatus] = useState("idle"); // idle | loading | ready | empty | error

  useEffect(() => {
    let mounted = true;

    async function fetchData() {
      if (!adherentId) {
        if (!mounted) return;
        setUVs(null);
        setStatus("idle");
        return;
      }

      try {
        if (!mounted) return;
        setStatus("loading");

        const uvData = await getUVById(adherentId);

        // Normalisation : parfois API renvoie un tableau, parfois un objet
        const normalized = Array.isArray(uvData) ? uvData[0] : uvData;

        // "Pas de résultats" => message, pas d'erreur
        const isEmptyObject =
          normalized &&
          typeof normalized === "object" &&
          !Array.isArray(normalized) &&
          Object.keys(normalized).length === 0;

        if (!normalized || isEmptyObject) {
          if (!mounted) return;
          setUVs(null);
          setStatus("empty");
          return;
        }

        if (!mounted) return;
        setUVs(normalized);
        setStatus("ready");
      } catch (error) {
        // Si c'est un "not found", on considère ça comme "pas d'UV"
        const httpStatus = error?.response?.status;
        if (httpStatus === 404 || httpStatus === 204) {
          if (!mounted) return;
          setUVs(null);
          setStatus("empty");
          return;
        }

        console.error("Erreur lors de la récupération des UVs :", error);
        if (!mounted) return;
        setUVs(null);
        setStatus("error");
      }
    }

    fetchData();
    return () => {
      mounted = false;
    };
  }, [adherentId]);

  const renderUvIcon = (value) => (value ? "☑️" : "🔲");

  if (status === "idle") return null;

  // Petit container commun (pour garder le même style)
  const Box = ({ children }) => (
    <div className="bg-gray-100 dark:bg-gray-500 px-6 pt-2 pb-4 shadow-lg max-w-[800px] mx-auto font-montserrat">
      <div className="bg-gray-300 dark:bg-gray-600 p-4 rounded">{children}</div>
    </div>
  );

  if (status === "loading") {
    return (
      <Box>
        <h3 className="text-2xl font-light uppercase mb-2 text-left">
          Validation des UV
        </h3>
        <p className="text-sm text-gray-700 dark:text-gray-200">
          Chargement des UV…
        </p>
      </Box>
    );
  }

  if (status === "empty") {
    return (
      <Box>
        <h3 className="text-2xl font-light uppercase mb-2 text-left">
          Validation des UV
        </h3>
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-4">
          <p className="text-sm text-gray-700 dark:text-gray-200">
            Aucune UV enregistrée pour cet adhérent.
          </p>
        </div>
      </Box>
    );
  }

  if (status === "error") {
    return (
      <Box>
        <h3 className="text-2xl font-light uppercase mb-2 text-left">
          Validation des UV
        </h3>
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-4">
          <p className="text-sm text-red-700 dark:text-red-200">
            Impossible de récupérer les UV pour le moment.
          </p>
        </div>
      </Box>
    );
  }

  // status === "ready"
  return (
    <div className="bg-gray-100 dark:bg-gray-500 px-6 pt-2 pb-4 shadow-lg max-w-[800px] mx-auto font-montserrat">
      <div className="bg-gray-300 dark:bg-gray-600 p-4 rounded">
        <h3 className="text-2xl font-light uppercase mb-4 text-left">
          Validation des UV
        </h3>

        <div className="space-y-4">
          <div className="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-4">
            <div className="flex flex-wrap justify-between text-sm text-gray-700 dark:text-gray-300">
              {/* Première ligne : UV1 à UV5 */}
              <div className="flex flex-row w-full justify-between">
                {Array.from({ length: 5 }, (_, i) => (
                  <div key={`uv${i + 1}`} className="flex items-center gap-2">
                    <span className="font-semibold">UV{i + 1} :</span>
                    <span>{renderUvIcon(uvs?.[`uv${i + 1}`])}</span>
                  </div>
                ))}
              </div>

              {/* Deuxième ligne : UV6 à UV9 */}
              <div className="flex flex-row w-full justify-between mt-4">
                {Array.from({ length: 4 }, (_, i) => (
                  <div key={`uv${i + 6}`} className="flex items-center gap-2">
                    <span className="font-semibold">UV{i + 6} :</span>
                    <span>{renderUvIcon(uvs?.[`uv${i + 6}`])}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AdherentUV;
